import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  resumeTicketsSaleModalVar,
  stopTicketsSaleModalVar,
} from "../../../graphql/globalVar/state";
import { useEventActions } from "../../../hooks/useEventActions";

import stop_sales from "./img/stop-sales.webp";

function StopTicketsSaleModal() {
  const stopEventId = useReactiveVar(stopTicketsSaleModalVar);
  const resumeEventId = useReactiveVar(resumeTicketsSaleModalVar);
  const { t } = useTranslation();
  const { stopTicketSales, resumeTicketSales, stopLoading, resumeLoading } =
    useEventActions();

  const isStop = stopEventId !== null;
  const eventId = isStop ? stopEventId : resumeEventId;
  const loading = stopLoading || resumeLoading;

  const handleClose = () => {
    stopTicketsSaleModalVar(null);
    resumeTicketsSaleModalVar(null);
  };

  const handleConfirm = () => {
    if (!eventId) return;
    if (isStop) stopTicketSales(eventId);
    else resumeTicketSales(eventId);
  };

  return (
    <Modal
      show={eventId !== null}
      onHide={handleClose}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fw-bold">
          {isStop
            ? t("events.modals.stopSales.stopTitle")
            : t("events.modals.stopSales.resumeTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-muted p-3 fs-6">
        {isStop ? (
          <>
            <p className="fs-6 text-dark mb-3">
              {t("events.modals.stopSales.hasSales")}
            </p>
            <div className="gap-3 gap-md-4 p-2 p-md-3 d-flex flex-column flex-md-row justify-content-center align-items-center mb-3">
              <img
                src={stop_sales}
                height={96}
                alt="stop tickets sales picture"
              />
              <div className="text-start">
                <p className="text-info mb-2">
                  {t("events.modals.stopSales.stoppingWill")}
                </p>
                <ul className="ps-3 m-0 text-info fs-6">
                  <li>{t("events.modals.stopSales.removeListings")}</li>
                  <li>{t("events.modals.stopSales.preventPurchases")}</li>
                  <li>{t("events.modals.stopSales.keepValid")}</li>
                </ul>
              </div>
            </div>
            <p className="fs-6 text-dark m-0">
              {t("events.modals.stopSales.canPublishAgain")}
            </p>
          </>
        ) : (
          <p className="fs-6 text-dark m-0">
            {t("events.modals.stopSales.resumeConfirm")}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col xs={4} md={6}>
            <Button
              variant="outline-success"
              className="w-100 py-3 rounded-3 fw-normal"
              onClick={handleClose}
              disabled={loading}
            >
              {t("events.cancel")}
            </Button>
          </Col>
          <Col xs={8} md={6}>
            <Button
              variant={isStop ? "warning-amber" : "success"}
              className="w-100 py-3 rounded-3 text-white"
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading
                ? t("events.loading")
                : isStop
                  ? t("events.modals.stopSales.stopConfirm")
                  : t("events.modals.stopSales.resumeConfirmBtn")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default StopTicketsSaleModal;
